import type { SVGProps } from 'react';

export const Locked = ({ className, ...svgProps }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="17"
      viewBox="0 0 13 17"
      width="13"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7828_227499)">
        <path
          d="M3.76286 6.03629V4.60376C3.76286 3.97233 4.01369 3.36675 4.46019 2.92026C4.90668 2.47377 5.51224 2.22293 6.14368 2.22293C6.77511 2.22293 7.38068 2.47377 7.82717 2.92026C8.27366 3.36675 8.5245 3.97233 8.5245 4.60376V6.04638H9.98731V4.60376C9.98731 3.58437 9.58237 2.60672 8.86155 1.8859C8.14073 1.16508 7.16307 0.760132 6.14368 0.760132C5.12428 0.760132 4.14663 1.16508 3.42581 1.8859C2.70498 2.60672 2.30005 3.58437 2.30005 4.60376V6.04638L3.76286 6.03629Z"
          fill="#F97F3B"
          opacity="0.5"
        />
        <path
          d="M10.7542 5.99589H1.53348C1.32874 5.9905 1.12497 6.02619 0.934247 6.10083C0.743522 6.17547 0.569692 6.28757 0.422999 6.4305C0.276307 6.57344 0.159728 6.7443 0.0801555 6.93302C0.000582919 7.12175 -0.040354 7.3245 -0.0402831 7.52931V15.2166C-0.0402831 15.6233 0.121266 16.0133 0.408837 16.3009C0.696409 16.5884 1.08647 16.75 1.49315 16.75H10.7138C11.1214 16.75 11.5125 16.5888 11.8017 16.3015C12.0909 16.0142 12.2547 15.6242 12.2573 15.2166V7.52931C12.2548 7.1286 12.0966 6.74455 11.8161 6.45838C11.5356 6.17222 11.1548 6.00636 10.7542 5.99589ZM6.92065 13.6226H5.11481V8.88114H6.92065V13.6226Z"
          fill="#F97F3B"
        />
      </g>
      <defs>
        <clipPath id="clip0_7828_227499">
          <rect
            fill="white"
            height="16"
            transform="translate(0 0.75)"
            width="12.2976"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
